import appConfigurationService from "@/Services/AppConfigurationService";

const state = () => ({
  notifiqLancamentoEnabled: false,
  loading: false,
});

const mutations = {
  setNotifiqLancamentoEnabled(state, value) {
    state.notifiqLancamentoEnabled = Boolean(value);
  },
  setLoading(state, value) {
    state.loading = value;
  },
};

const actions = {
  async fetchNotifiqLancamentoStatus({ commit }) {
    commit("setLoading", true);
    try {
      const data = await appConfigurationService.getNotifiqLancamentoStatus();
      commit("setNotifiqLancamentoEnabled", data.enabled ?? false);
    } catch {
      commit("setNotifiqLancamentoEnabled", false);
    } finally {
      commit("setLoading", false);
    }
  },
};

const getters = {
  notifiqLancamentoEnabled: (state) => state.notifiqLancamentoEnabled,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
